import React, { useEffect, useState } from 'react'

import { Col, DataContainer, Row } from 'Components/shared/Container'
import { H2, Text } from 'Components/shared/Typography'
import Input from 'Components/shared/Input'
import Image from 'Components/shared/Image'
import { getResourcePhotos } from 'Store/clubs'

const safedecodeURI = str => {
  try {
    return decodeURI(str)
  } catch (e) {
    console.error('Error decoding URI:', e)
    return str // Return the original string if decoding fails
  }
}

const placeholderImage = 'https://via.placeholder.com/180x180.png?text=No+Image+Found'

export default ({ club, setSelectedClub, previewImages, setPreviewImages, masterClub }) => {
  const [photos, setPhotos] = useState()

  useEffect(async () => {
    const fetchedPhotos = await getResourcePhotos(previewImages, setPreviewImages)
    setPhotos(fetchedPhotos)
    // console.log('fetchedPhotos', fetchedPhotos)
  }, [masterClub])
  return (
    <>
      <DataContainer>
        <Row style={{ margin: '10px' }}>
          <H2>Resources</H2>
        </Row>
        <Row style={{ margin: '10px' }}>
          <Text style={{ paddingRight: '25px' }}>Resources Header</Text>
          <Input
            value={
              club?.couponbtn?.coupondata?.sponsorheader?._text
                ? safedecodeURI(club.couponbtn.coupondata.sponsorheader._text)
                : ''
            }
            onChange={e => {
              setSelectedClub({
                ...club,
                couponbtn: {
                  ...club.couponbtn,
                  coupondata: {
                    ...club.couponbtn.coupondata,
                    sponsorheader: { _text: e.target.value }
                  }
                }
              })
            }}
          />
        </Row>
        <Row style={{ margin: '10px' }}>
          <Col style={{ width: '50%', alignItems: 'center' }}>
            <Image
              src={photos?.image1?.src ? photos.image1.src : placeholderImage}
              style={{ height: '144px', width: '144px', margin: '5px' }}
            />
            <Input
              type="file"
              accept="image/*"
              id="resource1Input"
              containerMargin="4px"
              fullWidth
              onChange={e => {
                setPreviewImages({
                  ...previewImages,
                  image1: { src: URL.createObjectURL(e.target.files[0]), file: e.target.files[0] }
                })
                setPhotos({
                  ...photos,
                  image1: { src: URL.createObjectURL(e.target.files[0]), file: e.target.files[0] }
                })
                setSelectedClub({
                  ...club,
                  couponbtn: {
                    ...club.couponbtn,
                    coupondata: {
                      ...club.couponbtn.coupondata,
                      image1: {
                        _text: `${club.clubId}-${e.target.files[0].name.replace(/-/g, '')}`
                      }
                    }
                  }
                })
              }}
            />
            <Input
              value={
                club.couponbtn?.coupondata.url1?._text
                  ? safedecodeURI(
                      club.couponbtn?.coupondata.url1?._text
                        .replace(/[⁄]/gm, `/`)
                        .replace(/&amp;frasl;|&frasl;/g, '/')
                    )
                  : ''
              }
              containerMargin="4px"
              fullWidth
              onChange={e => {
                setSelectedClub({
                  ...club,
                  couponbtn: {
                    ...club.couponbtn,
                    coupondata: { ...club.couponbtn.coupondata, url1: { _text: e.target.value } }
                  }
                })
              }}
            />
          </Col>
          <Col style={{ width: '50%', alignItems: 'center' }}>
            <Image
              src={photos?.image4?.src ? photos.image4.src : placeholderImage}
              style={{ height: '144px', width: '144px', margin: '5px' }}
            />
            <Input
              type="file"
              accept="image/*"
              id="resource4Input"
              containerMargin="4px"
              fullWidth
              onChange={e => {
                setPhotos({
                  ...photos,
                  image4: { src: URL.createObjectURL(e.target.files[0]), file: e.target.files[0] }
                })
                setPreviewImages({
                  ...previewImages,
                  image4: { src: URL.createObjectURL(e.target.files[0]), file: e.target.files[0] }
                })
                setSelectedClub({
                  ...club,
                  couponbtn: {
                    ...club.couponbtn,
                    coupondata: {
                      ...club.couponbtn.coupondata,
                      image4: {
                        _text: `${club.clubId}-${e.target.files[0].name.replace(/-/g, '')}`
                      }
                    }
                  }
                })
              }}
            />
            <Input
              value={
                club.couponbtn?.coupondata.url4?._text
                  ? safedecodeURI(
                      club.couponbtn?.coupondata.url4?._text
                        .replace(/[⁄]/gm, `/`)
                        .replace(/&amp;frasl;|&frasl;/g, '/')
                    )
                  : ''
              }
              fullWidth
              onChange={e => {
                setSelectedClub({
                  ...club,
                  couponbtn: {
                    ...club.couponbtn,
                    coupondata: { ...club.couponbtn.coupondata, url4: { _text: e.target.value } }
                  }
                })
              }}
            />
          </Col>
        </Row>
        <Row style={{ margin: '10px' }}>
          <Col style={{ width: '50%', alignItems: 'center' }}>
            <Image
              src={photos?.image2?.src ? photos.image2.src : placeholderImage}
              style={{ height: '144px', width: '144px', margin: '5px' }}
            />
            <Input
              type="file"
              accept="image/*"
              id="resource2Input"
              containerMargin="4px"
              fullWidth
              onChange={e => {
                setPhotos({
                  ...photos,
                  image2: { src: URL.createObjectURL(e.target.files[0]), file: e.target.files[0] }
                })
                setPreviewImages({
                  ...previewImages,
                  image2: { src: URL.createObjectURL(e.target.files[0]), file: e.target.files[0] }
                })
                setSelectedClub({
                  ...club,
                  couponbtn: {
                    ...club.couponbtn,
                    coupondata: {
                      ...club.couponbtn.coupondata,
                      image2: {
                        _text: `${club.clubId}-${e.target.files[0].name.replace(/-/g, '')}`
                      }
                    }
                  }
                })
              }}
            />
            <Input
              value={
                club.couponbtn?.coupondata.url2?._text
                  ? safedecodeURI(
                      club.couponbtn?.coupondata.url2?._text
                        .replace(/[⁄]/gm, `/`)
                        .replace(/&amp;frasl;|&frasl;/g, '/')
                    )
                  : ''
              }
              fullWidth
              onChange={e => {
                setSelectedClub({
                  ...club,
                  couponbtn: {
                    ...club.couponbtn,
                    coupondata: { ...club.couponbtn.coupondata, url2: { _text: e.target.value } }
                  }
                })
              }}
            />
          </Col>
          <Col style={{ width: '50%', alignItems: 'center' }}>
            <Image
              src={photos?.image5?.src ? photos.image5.src : placeholderImage}
              style={{ height: '144px', width: '144px', margin: '5px' }}
            />
            <Input
              type="file"
              accept="image/*"
              id="resource5Input"
              containerMargin="4px"
              fullWidth
              onChange={e => {
                setPhotos({
                  ...photos,
                  image5: { src: URL.createObjectURL(e.target.files[0]), file: e.target.files[0] }
                })
                setPreviewImages({
                  ...previewImages,
                  image5: { src: URL.createObjectURL(e.target.files[0]), file: e.target.files[0] }
                })
                setSelectedClub({
                  ...club,
                  couponbtn: {
                    ...club.couponbtn,
                    coupondata: {
                      ...club.couponbtn.coupondata,
                      image5: {
                        _text: `${club.clubId}-${e.target.files[0].name.replace(/-/g, '')}`
                      }
                    }
                  }
                })
              }}
            />
            <Input
              value={
                club.couponbtn?.coupondata.url5._text
                  ? safedecodeURI(
                      club.couponbtn?.coupondata.url5?._text
                        .replace(/[⁄]/gm, `/`)
                        .replace(/&amp;frasl;|&frasl;/g, '/')
                    )
                  : ''
              }
              onChange={e => {
                setSelectedClub({
                  ...club,
                  couponbtn: {
                    ...club.couponbtn,
                    coupondata: { ...club.couponbtn.coupondata, url5: { _text: e.target.value } }
                  }
                })
              }}
              fullWidth
            />
          </Col>
        </Row>
        <Row style={{ margin: '10px' }}>
          <Col style={{ width: '50%', alignItems: 'center' }}>
            <Image
              src={photos?.image3?.src ? photos.image3.src : placeholderImage}
              style={{ height: '144px', width: '144px', margin: '5px' }}
            />
            <Input
              type="file"
              accept="image/*"
              id="resource3Input"
              containerMargin="4px"
              fullWidth
              onChange={e => {
                setPhotos({
                  ...photos,
                  image3: { src: URL.createObjectURL(e.target.files[0]), file: e.target.files[0] }
                })
                setPreviewImages({
                  ...previewImages,
                  image3: {
                    src: URL.createObjectURL(e.target.files[0]),
                    file: e.target.files[0]
                  }
                })
                setSelectedClub({
                  ...club,
                  couponbtn: {
                    ...club.couponbtn,
                    coupondata: {
                      ...club.couponbtn.coupondata,
                      image3: {
                        _text: `${club.clubId}-${e.target.files[0].name.replace(/-/g, '')}`
                      }
                    }
                  }
                })
              }}
            />
            <Input
              value={
                club.couponbtn?.coupondata.url3?._text
                  ? safedecodeURI(
                      club.couponbtn?.coupondata.url3?._text
                        .replace(/[⁄]/gm, `/`)
                        .replace(/&amp;frasl;|&frasl;/g, '/')
                    )
                  : ''
              }
              fullWidth
              onChange={e => {
                setSelectedClub({
                  ...club,
                  couponbtn: {
                    ...club.couponbtn,
                    coupondata: { ...club.couponbtn.coupondata, url3: { _text: e.target.value } }
                  }
                })
              }}
            />
          </Col>
          <Col style={{ width: '50%', alignItems: 'center' }}>
            <Image
              src={photos?.image6?.src ? photos.image6.src : placeholderImage}
              style={{ height: '144px', width: '144px', margin: '5px' }}
            />
            <Input
              type="file"
              accept="image/*"
              id="resource6Input"
              containerMargin="4px"
              fullWidth
              onChange={e => {
                setPhotos({
                  ...photos,
                  image6: { src: URL.createObjectURL(e.target.files[0]), file: e.target.files[0] }
                })
                setPreviewImages({
                  ...previewImages,
                  image6: { src: URL.createObjectURL(e.target.files[0]), file: e.target.files[0] }
                })
                setSelectedClub({
                  ...club,
                  couponbtn: {
                    ...club.couponbtn,
                    coupondata: {
                      ...club.couponbtn.coupondata,
                      image6: {
                        _text: `${club.clubId}-${e.target.files[0].name.replace(/-/g, '')}`
                      }
                    }
                  }
                })
              }}
            />
            <Input
              value={
                club.couponbtn?.coupondata.url6?._text
                  ? safedecodeURI(
                      club.couponbtn?.coupondata.url6?._text
                        .replace(/[⁄]/gm, `/`)
                        .replace(/&amp;frasl;|&frasl;/g, '/')
                    )
                  : ''
              }
              fullWidth
              onChange={e => {
                setSelectedClub({
                  ...club,
                  couponbtn: {
                    ...club.couponbtn,
                    coupondata: { ...club.couponbtn.coupondata, url6: { _text: e.target.value } }
                  }
                })
              }}
            />
          </Col>
        </Row>
        {/*
self enroll section
          */}
        {club.auto_enroll?._text === 'YES' && (
          <Row>
            <Col style={{ width: '50%', alignItems: 'center' }}>
              <Text style={{ paddingRight: '25px' }}>Self Enroll Button</Text>
              <Image
                src={photos?.image7?.src ? photos.image7.src : placeholderImage}
                style={{ height: '125px', width: '170px', margin: '5px' }}
              />
              <Input
                type="file"
                accept="image/*"
                id="resource7Input"
                containerMargin="4px"
                fullWidth
                onChange={e => {
                  setPhotos({
                    ...photos,
                    image7: { src: URL.createObjectURL(e.target.files[0]), file: e.target.files[0] }
                  })
                  setPreviewImages({
                    ...previewImages,
                    image7: { src: URL.createObjectURL(e.target.files[0]), file: e.target.files[0] }
                  })
                  setSelectedClub({
                    ...club,
                    couponbtn: {
                      ...club.couponbtn,
                      coupondata: {
                        ...club.couponbtn.coupondata,
                        image7: {
                          _text: `${club.clubId}-${e.target.files[0].name.replace(/-/g, '')}`
                        }
                      }
                    }
                  })
                }}
              />
              <Input
                value={
                  club.couponbtn?.coupondata.url7?._text
                    ? safedecodeURI(
                        club.couponbtn?.coupondata.url7?._text
                          .replace(/[⁄]/gm, `/`)
                          .replace(/&amp;frasl;|&frasl;/g, '/')
                      )
                    : ''
                }
                fullWidth
                onChange={e => {
                  setSelectedClub({
                    ...club,
                    couponbtn: {
                      ...club.couponbtn,
                      coupondata: { ...club.couponbtn.coupondata, url7: { _text: e.target.value } }
                    }
                  })
                }}
              />
            </Col>
          </Row>
        )}
      </DataContainer>
    </>
  )
}
